import React, { useState, useRef, useEffect } from "react";
import "../CSS/HomePage.css";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import homeBanner from '../Images/home/home-page-banner.png';
import homeBannerMob from '../Images/Mobile Images/home/home-page-banner-mob.png';
import transformingCpoImage from '../Images/home/transforming-cpo-section-image.png';
import achieveLastingImpactSvg from '../Images/home/achieve-lasting-impact-section-image.svg';
import achieveLastingImpactSvgMob from '../Images/Mobile Images/home/achieve-lasting-impact-section-image-mob.svg';
import achieveLastingImpactJoint from '../Images/home/achieve-lasting-impact-section-joint-image.png';
import hqSolutionsSectionImage from '../Images/home/hq-solutions-section-image.svg';
import impactNursingShortageImage from '../Images/home/impact-nursing-shortage-crisis-section-image.svg';
import impactNursingShortageImageMob from '../Images/Mobile Images/home/impact-nusring-shortage-crisis-section-image-mob.svg';
import codingIcon from '../Images/home/Icons/coding-icon.svg';
import utilizationManagementIcon from '../Images/home/Icons/utilization-management-icon.svg';
import billReviewIcon from '../Images/home/Icons/bill-review-icon.svg';
import patientCareIcon from '../Images/home/Icons/patient-care-icon.svg';
import absenceDisabilityIcon from '../Images/home/Icons/absence-&-disability-management-icon.svg';
import csoAnalyticsIcon from '../Images/home/Icons/cso-analytics-icon.svg';

const TABS = [
  {
    label: "Coding",
    icon: <img src={codingIcon} alt="Coding" style={{ height: 64, width: 64 }} />,
    title: "Coding Services",
    desc: "Our Specialized teams of certified coders focused on reducing your coding backlog and enhancing quality. Also, helps to drive better financial outcomes with optimized RCM coding. We turn data into revenue through meticulous and accurate coding practices."
  },
  {
    label: "Utilization Management",
    icon: <img src={utilizationManagementIcon} alt="Utilization Management" style={{ height: 64, width: 64 }} />,
    title: "Utilization Management",
    desc: "Effective utilization management, powered by dedicated teams of experienced clinicians cross-trained across specialties, is crucial to significantly reduce the rising rates of healthcare costs while ensuring high-quality, appropriate patient care."
  },
  {
    label: "Bill Review",
    icon: <img src={billReviewIcon} alt="Bill Review" style={{ height: 64, width: 64 }} />,
    title: "Bill Review",
    desc: "With dedicated teams of certified bill reviewers, we ensure a low aging of bills and enhance quality, ultimately leading to substantial reductions in healthcare costs."
  },
  {
    label: "Patient Care",
    icon: <img src={patientCareIcon} alt="Patient Care" style={{ height: 64, width: 64 }} />,
    title: "Patient Care",
    desc: "Our highly skilled, experienced registered nurses are crucial for the long-term recruitment and retention of quality nurses, all dedicated to serving your patients and community."
  },
  {
    label: "Absence & Disability Management",
    icon: <img src={absenceDisabilityIcon} alt="Absence & Disability Management" style={{ height: 64, width: 64 }} />,
    title: "Absence & Disability Management",
    desc: "By leveraging dedicated teams of experienced and trained professionals to manage and track employee absences, we effectively reduce industry pressure on claim operations."
  },
  {
    label: "CSO Analytics",
    icon: <img src={csoAnalyticsIcon} alt="CSO Analytics" style={{ height: 64, width: 64 }} />,
    title: "CSO Analytics",
    desc: "Our solutions are designed to ensure accuracy and eliminate manual entry, leading to more efficient and reliable operations."
  }
];

const CLINICAL_POINTS_LABELS = [
  { desktop: <>Identify your precise<br />clinical team needs</>, mobile: "Identify your precise clinical team needs" },
  { desktop: <>Build Your Dedicated<br />Clinical Team with Us</>, mobile: "Build Your Dedicated Clinical Team with Us" },
  { desktop: <>Accelerate Production for<br />Greater Clinical Impact</>, mobile: "Accelerate Production for Greater Clinical Impact" },
];

const HomePage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [isMobileTimeline, setIsMobileTimeline] = useState(false);
  const elevateRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 1100px)");
    const handle = () => setIsMobileTimeline(mq.matches);
    handle();
    mq.addEventListener("change", handle);
    return () => mq.removeEventListener("change", handle);
  }, []);

  return (
    <>
      <div className="home_banner" style={{ '--banner-bg': `url(${homeBanner})`, '--banner-bg-mob': `url(${homeBannerMob})`, background: `url(${homeBanner}) center/cover no-repeat`, position: 'relative' } as React.CSSProperties}>
        <div className="home_banner-content" style={{ position: 'relative', zIndex: 2 }}>
          <h2 className="home_banner-subtitle">Transforming Clinical Process Outsourcing</h2>
          <h1 className="home_banner-title">
            Reducing Administrative Burden,<br />
            Enhancing Patient Care.
          </h1>
          <p className="home_banner-desc">
            Medwell360 leverages global delivery to offer tailored clinical solutions at scale for hospitals, health plans, managed care organizations, life sciences companies, and absence management services.
          </p>
          <button className="home_banner-btn">Get Started</button>
        </div>
      </div>

      <div className="zemantics_statistics">
        <div className="statistics-left">
          <picture>
            <source media="(max-width: 1100px)" srcSet={impactNursingShortageImageMob} />
            <img src={impactNursingShortageImage} alt="Impact of the Nursing Shortage Crisis" className="statistics-left-image" />
          </picture>
        </div>
        <div className="statistics-right">
          <h2 className="statistics-right-title">Enhance Your Team with Expert Remote Clinicians and Bedside Nurses</h2>
          <p className="statistics-right-desc">
            We deliver both remote and onsite clinical teams that extend the capacity and effectiveness of your clinical staff, allowing you to concentrate on what truly matters.
          </p>
        </div>
      </div>

      <div className="clinical_processing">
        <div className="clinical_processing-left">
          <h2 className="clinical_processing-title">Transforming Clinical Process Outsourcing</h2>
          <p className="clinical_processing-desc">
            Clinical Process Outsourcing involves healthcare-related administrative tasks that benefit from or require clinical expertise. This serves as an innovative approach to elevate traditional Business Process Outsourcing.
          </p>
          <p className="clinical_processing-desc">
            Our clinical proficiency is grounded in a commitment to quality, offering flexible support options both in-person and virtually. We excel in navigating complex clinical workflows while ensuring adherence to industry standards for security and compliance.
          </p>
        </div>
        <div className="clinical_processing-right">
          <img src={transformingCpoImage} alt="Transforming CPO Section" className="clinical_processing-image" />
        </div>
      </div>

      <div className="global_leader_statistic">
        <h2 className="global_leader_title">Global Leader with Deep Clinical Experience</h2>
        <div className="global_leader_stats_row">
          <div className="global_leader_stat">
            <div className="global_leader_stat_value">4,000+</div>
            <div className="global_leader_stat_label">Nurses & Practitioners</div>
          </div>
          <div className="global_leader_stat">
            <div className="global_leader_stat_value">100%</div>
            <div className="global_leader_stat_label">Clinical Focus</div>
          </div>
          <div className="global_leader_stat">
            <div className="global_leader_stat_value">Up to 60%</div>
            <div className="global_leader_stat_label">Cost Savings</div>
          </div>
          <div className="global_leader_stat">
            <div className="global_leader_stat_value">30 M+</div>
            <div className="global_leader_stat_label">Charts & Cases/ Year</div>
          </div>
          <div className="global_leader_stat">
            <div className="global_leader_stat_value">6 M+</div>
            <div className="global_leader_stat_label">Calls to Patients/ Year</div>
          </div>
        </div>
      </div>

      <div className="outstanding_results">
        <h2 className="outstanding_results_title">Achieving Outstanding Results with Clinical Expertise</h2>
        <div className="outstanding_results_cards">
          <div className="outstanding_results_card">
            <div className="outstanding_results_card_title">Enhance Care Quality</div>
            <div className="outstanding_results_card_desc">Prioritize patient-centered care while minimizing administrative workloads.</div>
          </div>
          <div className="outstanding_results_card">
            <div className="outstanding_results_card_title">Optimize Clinical Processes</div>
            <div className="outstanding_results_card_desc">Integrate clinical knowledge with Six Sigma process efficiency and cutting-edge technology.</div>
          </div>
          <div className="outstanding_results_card">
            <div className="outstanding_results_card_title">Lower Costs</div>
            <div className="outstanding_results_card_desc">Cut labor expenses and boost revenue through precise, efficient reviews.</div>
          </div>
        </div>
      </div>

      <div
        className="elevate_clinical_teams"
        ref={elevateRef}
      >
        <h2 className="elevate_clinical_teams_title">Elevating Your Clinical Teams with Quality-Driven Solutions</h2>
        <div className="elevate_clinical_teams_content">
          <div className="elevate_clinical_teams_tabs">
            {TABS.map((tab, idx) => (
              <div
                key={tab.label}
                className={`elevate_tab${activeTab === idx ? " active" : ""}`}
                onClick={() => setActiveTab(idx)}
              >
                <div className="elevate_tab_number">{idx + 1}</div>
                <div className="elevate_tab_label">{tab.label}</div>
              </div>
            ))}
          </div>
          <div
            className="elevate_clinical_teams_panel"
            onTouchStart={(e) => {
              const touchDown = e.touches[0].clientX;
              e.currentTarget.setAttribute('data-touch-start', touchDown.toString());
            }}
            onTouchMove={(e) => {
              const touchDown = e.currentTarget.getAttribute('data-touch-start');
              if (!touchDown) return;
              const currentTouch = e.touches[0].clientX;
              const diff = Number(touchDown) - currentTouch;
              if (diff > 5) {
                // Swipe Left -> Next
                setActiveTab((prev) => (prev + 1) % TABS.length);
                e.currentTarget.removeAttribute('data-touch-start');
              } else if (diff < -5) {
                // Swipe Right -> Prev
                setActiveTab((prev) => (prev - 1 + TABS.length) % TABS.length);
                e.currentTarget.removeAttribute('data-touch-start');
              }
            }}
          >
            <div
              className="mobile-nav-arrow mobile-nav-prev"
              onClick={() => setActiveTab((prev) => (prev - 1 + TABS.length) % TABS.length)}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
            </div>

            <div className="elevate_clinical_teams_panel_content">
              <div className="elevate_clinical_teams_icon">{TABS[activeTab].icon}</div>
              <div className="elevate_clinical_teams_panel_title">{TABS[activeTab].title}</div>
              <div className="elevate_clinical_teams_panel_desc">{TABS[activeTab].desc}</div>
            </div>

            <div
              className="mobile-nav-arrow mobile-nav-next"
              onClick={() => setActiveTab((prev) => (prev + 1) % TABS.length)}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
            </div>
          </div>
        </div>
      </div>

      <div className="clinical_points">
        <h2 className="clinical_points_title">Achieve lasting impact with simple implementation</h2>
        <div className="clinical_points_subtitle">Managing your extended clinical team becomes effortless with our support.</div>
        <div className="clinical_points_content">
          <div className="clinical_points_timeline" style={{ position: 'relative' }}>
            <picture>
              <source media="(max-width: 1100px)" srcSet={achieveLastingImpactSvgMob} />
              <img src={achieveLastingImpactSvg} alt="Achieve Lasting Impact Timeline" className="clinical_points_timeline_img" />
            </picture>
            <div className="clinical_points_timeline_labels_absolute">
              {CLINICAL_POINTS_LABELS.map((item, idx) => (
                <div key={idx} className="clinical_points_timeline_label">
                  {isMobileTimeline ? item.mobile : item.desktop}
                </div>
              ))}
            </div>
          </div>
          <div className="clinical_points_illustration">
            <img src={achieveLastingImpactJoint} alt="Achieve Lasting Impact Joint" className="clinical_points_illustration_img" />
          </div>
        </div>
      </div>

      <div className="hq_solutions">
        <div className="hq_solutions_left">
          <img src={hqSolutionsSectionImage} alt="HQ Solutions Section" className="hq_solutions_illustration_img" />
        </div>
        <div className="hq_solutions_right">
          <h2 className="hq_solutions_title">High-Quality Solutions for Growing Your Clinical Teams</h2>
          <div className="hq_solutions_subtitle">We offer a variety of services, each perfectly matched to your unique requirements.</div>
        </div>
      </div>
    </>
  );
};

export default HomePage; 